import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface TicketData {
  ticketSubject: string;
  ticketId: string;
  ticketStatus: string;
  internalTicketId: number;
}

type SliceStateType = {
  ingestionEndpointSuccess: boolean;
  ticket: TicketData;
};

const initialState: SliceStateType = {
  ingestionEndpointSuccess: false,
  ticket: {
    ticketSubject: "",
    ticketId: "",
    ticketStatus: "",
    internalTicketId: 0
  }
};

const cookedTicketSlice = createSlice({
  name: "cookedTicket",
  initialState,
  reducers: {
    updateCookedTicket: (state, action: PayloadAction<TicketData>) => {
      state.ticket = action.payload;
    },
    updateIngestionEndpointSuccess: (state, action: PayloadAction<boolean>) => {
      state.ingestionEndpointSuccess = action.payload;
    }
  }
});

export const { updateCookedTicket, updateIngestionEndpointSuccess } =
  cookedTicketSlice.actions;

export default cookedTicketSlice.reducer;
